import { css } from 'styled-system/css';

export const labelStyle = css.raw({
  textStyle: 'v2.meta',
  color: 'v2.text.muted',
});

/** table cell value: 400 12px Inter tabular, --text-2 (HL/Ostium weight) */
export const valueStyle = css.raw({
  fontFamily: 'Inter',
  fontSize: '12px',
  fontWeight: '400',
  lineHeight: '1.35',
  fontVariantNumeric: 'tabular-nums',
  color: 'v2.text.secondary',
  w: 'fit-content', // allow tooltip to be centered
});

/** mockup .subcell: 400 10px mono, --text-4 */
export const subValueStyle = css.raw({
  fontFamily: 'Inter',
  fontSize: '10px',
  fontWeight: '400',
  lineHeight: '1.35',
  fontVariantNumeric: 'tabular-nums',
  color: 'v2.text.subtle',
  w: 'fit-content',
});

/**
 * V2 side pill (Long/Short): Ostium-quiet — dim tint bg + accent text,
 * NO border, sentence case, mono 10.5px, radius 2. Spread onto
 * <LongShortBadge /> which accepts BadgeProps after its own defaults.
 */
export const getSidePillProps = (_isLong: boolean) =>
  ({
    borderRadius: '2px',
    border: 'none',
    fontFamily: 'Inter',
    fontSize: '10.5px',
    fontWeight: '500',
    letterSpacing: '0em',
    textTransform: 'none',
    px: '6px',
    py: '3px',
    h: 'auto',
  }) as const;
